import { useEffect, useState } from "react";
import { GetTrackingRecordSaveParams } from "@/api/track/interface";
import { useTrackingRecordSave } from "@/api/track/use-query";

const useElementExposure = (
  elementRef: React.RefObject<HTMLElement>,
  params: GetTrackingRecordSaveParams,
  isOnce?: boolean,
  trackFlag?: boolean
) => {
  const { mutate: fetchTrackingRecordSave } = useTrackingRecordSave();
  const [isFirst, $isFirst] = useState<boolean>(false);
  useEffect(() => {
    if (trackFlag) {
      fetchTrackingRecordSave(params);
    }
  }, [trackFlag, params, fetchTrackingRecordSave]);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !isFirst) {
          if (isOnce) $isFirst(true);
          fetchTrackingRecordSave(params);
        }
      });
    });

    observer.observe(element);
    return () => {
      observer.disconnect();
    };
  }, [elementRef, params, fetchTrackingRecordSave, isOnce, isFirst]);
};

export default useElementExposure;
